module.exports = {
  messages: {
    CN: {
      freeModalTitle: "试用期还剩 X 天",
      freeModelSubTitle: "过期后",
      freeModelTipTxt1: "销售代表核心功能不可使用",
      freeModelTipTxt2: "历史创建销售任务无法查看",
      freeModelTipTxt3: "无法使用高级数据看板",
      freeModeBtnTxt: "立即支付",
      freeModeBtnTxt1: "继续使用免费版本",
      CampaignModalTipTxt:
        "由于Linkedin限制好友数小于1的账户主动添加好友。您的LinkedIn账号 AAA 暂时无法添加好友，所有运行中的任务暂时关闭，请您使用Linkedin添加好友大于1后重新尝试打开任务。如有疑问，请联系客户支持",
      CampaignModalTipBtn: "我知道了",
      bindModalTitlePrefix: "还差最后一步 —— ",
      bindModalTitleMatch: "",
      bindModalTitleSuffix: " 正在等待联系",
      bindModalMatchedCustomer: "位客户",
      bindModalMatchedCandidate: "位候选人",
      bindModalSalesVersionLabel: "销售版本",
      bindModalSalesVersionText: "还差最后一步 —— 240 位客户正在等待联系",
      bindModalDesc:
        "您的活动已全部配置完毕（LinkedIn 已连接、受众已匹配、消息已就绪）",
      bindModalDescBold: "立即发布即可开启。",
      bindModalPendingBadge: "待发布",
      bindModalStatsSuffix: " 位候选人已匹配",
      bindModalStatsReplies: "首轮回复预计 ~1-3 天",
      bindModalStatsCreated: "创建于 {date}",
      bindModalNoticePrefix: "发布即开启您的 ",
      bindModalNoticeBold: "10 天免费试用",
      bindModalNoticeSuffix: "（今天 $0）；第 10 天前可随时取消，零费用。",
      bindModalContinueBtn: "继续 · 先看看会带来什么",
      bindModalEditBtn: "编辑活动",
    },

    US: {
      freeModalTitle: "X days left in the trial period",
      freeModelSubTitle: "After expiration",
      freeModelTipTxt1: "Core sales rep features will be unavailable",
      freeModelTipTxt2: "Previously created sales campaigns cannot be viewed",
      freeModelTipTxt3: "Advanced dashboards are inaccessible",
      freeModeBtnTxt: "Pay now",
      freeModeBtnTxt1: "Continue using the free version",
      CampaignModalTipTxt:
        "Due to LinkedIn’s restriction on accounts with fewer than 1 connection actively adding friends, your LinkedIn account AAA is temporarily unable to add connections. All ongoing tasks have been paused. Please use LinkedIn to add at least one connection before attempting to resume the tasks. If you have any questions, please contact customer support.",
      CampaignModalTipBtn: "Got it",
      bindModalTitlePrefix: "One step left — ",
      bindModalTitleMatch: "",
      bindModalTitleSuffix: " are waiting to be contacted",
      bindModalMatchedCustomer: "customers",
      bindModalMatchedCandidate: "candidates",
      bindModalSalesVersionLabel: "Sales version",
      bindModalSalesVersionText: "One step left — 240 matched customers are waiting to be contacted",
      bindModalDesc:
        "Your campaign is fully configured (LinkedIn connected, audience matched, messaging ready)",
      bindModalDescBold: "publish to begin.",
      bindModalPendingBadge: "Pending launch",
      bindModalStatsSuffix: " candidates matched",
      bindModalStatsReplies: "first replies in ~1-3 days",
      bindModalStatsCreated: "created {date}",
      bindModalNoticePrefix: "Publishing starts your ",
      bindModalNoticeBold: "10-day free trial",
      bindModalNoticeSuffix:
        " ($0 today); cancel anytime before day 10 and pay nothing.",
      bindModalContinueBtn: "Continue · see what it’ll deliver first",
      bindModalEditBtn: "Edit campaign",
    },
    AR: {
      freeModalTitle: "تبقّى X يومًا في فترة التجربة",
      freeModelSubTitle: "بعد انتهاء الصلاحية",
      freeModelTipTxt1: "لن تكون الميزات الأساسية لمندوبي المبيعات متاحة",
      freeModelTipTxt2: "لا يمكن عرض المهام البيعية التي تم إنشاؤها سابقًا",
      freeModelTipTxt3: "لا يمكن الوصول إلى لوحات البيانات المتقدمة",
      freeModeBtnTxt: "قم بالترقية الآن",
      freeModeBtnTxt1: "استمر في استخدام النسخة المجانية",
      CampaignModalTipTxt:
        " نظرًا لقيود LinkedIn على الحسابات التي تحتوي على أقل من اتصال واحد، فإن حسابك على LinkedIn AAA غير قادر حاليًا على إضافة اتصالات. تم إيقاف جميع المهام الجارية مؤقتًا. يرجى استخدام LinkedIn لإضافة اتصال واحد على الأقل قبل محاولة استئناف المهام. إذا كانت لديك أي أسئلة، يرجى التواصل مع دعم العملاء.",
      CampaignModalTipBtn: "مفهوم.",
      bindModalTitlePrefix: "لم يتبقَّ سوى خطوة واحدة — ",
      bindModalTitleMatch: "",
      bindModalTitleSuffix: " ينتظرون التواصل معهم",
      bindModalMatchedCustomer: "عملاء",
      bindModalMatchedCandidate: "مرشحين",
      bindModalSalesVersionLabel: "إصدار المبيعات",
      bindModalSalesVersionText: "لم يتبق سوى خطوة واحدة — 240 عميلًا مطابقًا ينتظرون التواصل معهم",
      bindModalDesc:
        "تمّ ضبط حملتك بالكامل (تمّ ربط LinkedIn ومطابقة الجمهور وتجديد الرسائل جاهزة)",
      bindModalDescBold: "انشر لتبدأ.",
      bindModalPendingBadge: "في انتظار الإطلاق",
      bindModalStatsSuffix: " مرشّح مطابق",
      bindModalStatsReplies: " الردود الأولى خلال ~1-3 أيام",
      bindModalStatsCreated: "تمّ الإنشاء في {date}",
      bindModalNoticePrefix: "بدء النشر يُفعّل ",
      bindModalNoticeBold: "تجربتك المجانية لمدة 10 أيام",
      bindModalNoticeSuffix:
        " (0$ اليوم)؛ يمكنك الإلغاء في أي وقت قبل اليوم 10 بدون أي رسوم.",
      bindModalContinueBtn: "متابعة · شاهد ما ستحصل عليه أوّلاً",
      bindModalEditBtn: "تعديل الحملة",
    },
  },
};
